// Imports
import { useEffect, useRef } from 'react';
import { NavigationType, useLocation, useNavigationType } from 'react-router-dom';

function useScrollToElementOnLoad(elementRef: React.RefObject<HTMLElement>, loadedData: any): void {
	// Use React Router functionality
	const location = useLocation();
	const navigationType = useNavigationType();
	
	
	// Use ref
	const lastScrolledLocationKeyRef = useRef<string | null>(null);
	
	
	// Scroll to the article title once it loads, skipping back/forward navigation
	//  -> Back/forward navigation has its own scroll restoration handling
	useEffect(() => {
		if (!loadedData || navigationType === NavigationType.Pop) {
			return;
		}
		
		if (lastScrolledLocationKeyRef.current === location.key) {
			return;
		}
		
		lastScrolledLocationKeyRef.current = location.key;
		elementRef.current?.scrollIntoView({ behavior: 'smooth' });
	}, [elementRef, loadedData, navigationType, location.key]);
}

export default useScrollToElementOnLoad;
